// No imports needed


export interface ReloadSideBarState {
  reloadSideBar: boolean;
}

export type SideBarAction =
  | { type: 'RELOAD_SIDEBAR'; payload: boolean }
;

export function sideBarReducer(state: ReloadSideBarState, action: SideBarAction): ReloadSideBarState {
  if (action.type === 'RELOAD_SIDEBAR') {
    return {
      ...state,
      reloadSideBar: action.payload,
    };
  }

  return state;
}